<h1 mat-dialog-title>Solicitar Desafiliación</h1> <br />

<form #desafiliacionForm=ngForm>
    <mat-dialog-content>

        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3"> <label> Fecha: </label> </div>

            <div class="col-lg-5">
                <input id="fechaDesafiliacion" name="fechaDesafiliacion" [(ngModel)]="data.fechaActual"
                    placeholder="Fecha desafiliación" class="form-control" type="date" [value]="data.fechaActual"/>

            </div>
            <div class="col-lg-3"> </div>
        </div>

        <br />
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3"> <label>Razones desafiliación: </label> </div>

            <div class="col-lg-8">
                <mat-select name="tipoRazon" [(ngModel)]="data.tipoRazon" (selectionChange)="muestraOtro()" required>
                    <mat-option value="-1">
                        SELECCIONE....
                    </mat-option>
                    <mat-option *ngFor="let tipo of this.data.tiposRazones" value="{{tipo.id}}">
                        {{tipo.descripcion}}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />

        <div class="row" *ngIf="data.otro == true">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3"> <label> Motivo desafiliación: </label> </div>

            <div class="col-lg-5">

                <textarea name="motivo" id="motivo" [(ngModel)]="data.motivo" class="form-control" cols="30"
                    rows="5"></textarea>

            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />

        <div class="row">
            <div class="col-lg-1"> </div>
            <div class="col-lg-8">
                <label>
                    <h4>
                        <strong>*</strong> La solicitud de desafiliación se hara efectiva sólo si el afiliado tiene
                        todos sus compromisos al día.
                        <br />
                        <br />
                        <strong>*</strong> Quienes decidan voluntariamente desafiliarse al Servicio de Bienestar no
                        podrán reincorporarse dentro de 6 meses
                        posteriores a la desafiliación.
                        <br />
                        <br />
                        <strong>*</strong> Quienes cuenten con convenio oncológico FALP serán desafiliados
                        automáticamente al desafiliarse del Bienestar.
                    </h4>
                </label>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-lg-1"> </div>
            <div class="col-lg-6">
                <input type="checkbox" [(ngModel)]="data.scales" id="scales" name="scales">
                <label for="scales">
                    <h3>Acepto Términos y Condiciones</h3>
                </label>
            </div>
            <div class="col-lg-8"></div>
        </div>

    </mat-dialog-content> <br />
</form>
<mat-dialog-actions>
    <!-- 
    <button mat-button class="mat-raised-button btn-success" (click)="onDesafiliarAfiliado(desafiliacionForm)">
        Guardar
    </button>
    -->
   
    <button class="boton-con-imagen"  (click)="onDesafiliarAfiliado(desafiliacionForm)">
        <img class="btn" src="assets/img/clave.png"  alt="validar desafiliación" style="alt:80%; width:80%"/>                        
    </button>       
    

    <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()" style="height:55%; width:38%">
        <i class="fa fa-trash"> </i> Salir
    </button>

</mat-dialog-actions>

<br />